import { Box, Card, DottedList, DottedListItem, Flex, Heading, Paragraph, TypeJobRequestIcon } from "@eworkit/iris";
import React from "react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { IJobRequest, getJobRequestClientInfo } from "@/data/job-requests";
import { formatMultipleLocationsWithCounter } from "@/data/locations";
import { router } from "@/views/router";

interface DashboardRecentlyViewedItemProps {
  item: IJobRequest;
}

export const DashboardRecentlyViewedItem: FC<DashboardRecentlyViewedItemProps> = ({ item }) => {
  const { t } = useTranslation("session");

  const { name: clientName } = getJobRequestClientInfo(item);

  return (
    <Card
      as={Link}
      to={
        router.get("job-requests.detail", {
          jobRequestId: item.id,
        }).path
      }>
      <Flex alignContent="center">
        <Box p="xxs" pr="md" pt="xs">
          <TypeJobRequestIcon color="vg500" size="lg" />
        </Box>
        <Box alignSelf="center">
          <Heading size="h-xs">{item.title}</Heading>
          <Box pt="xxs">
            <DottedList responsive={true}>
              <DottedListItem>
                <Paragraph size={["p-sm", null, null, "p-md"]} color="n700">
                  {clientName}
                </Paragraph>
              </DottedListItem>
              <DottedListItem>
                <Paragraph size={["p-sm", null, null, "p-md"]} color="n700">
                  {item.systemId}
                </Paragraph>
              </DottedListItem>
              <DottedListItem>
                <Paragraph size={["p-sm", null, null, "p-md"]} color="n700">
                  {formatMultipleLocationsWithCounter(t, item.locations)}
                </Paragraph>
              </DottedListItem>
            </DottedList>
          </Box>
        </Box>
      </Flex>
    </Card>
  );
};
